import React, { useEffect, useState } from 'react'
import Chart from "react-apexcharts"
import _ from 'lodash'

// Adding the chart and theme as dependency to the core fusioncharts

import { Row, Col } from 'react-bootstrap'
import * as moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { resetOverviewRevenue, retrieveOverviewRevenue, retrieveSelectionYears, setActiveSelectionYear } from '../../../../../redux/actions/overview'
import DashboardOverviewLoader from '../../loader-container'
import NumberFormat from 'react-number-format'
import './style.scss'

const Index = () => {

	const dispatch = useDispatch()

	const loading = useSelector(state => state.overview.fetchRevenue.loading)
	const sales = useSelector(state => state.overview.fetchRevenue.status)

	const userLoading = useSelector(state => state.user.fetchUserDetails.loading)
	const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)

	const selectionYears = useSelector(state => state && state.overview.selectionYears.status)
	const activeSelectionYear = useSelector(state => state.overview.activeSelectionYear)

	const [allSales, setAllSales] = useState({
		none:[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], 
		vat: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
	});

	const options = {
		chart: {
			id: "basic-bar",
			toolbar: {
				show: false
			}
		},
		colors: ['#5d88ff'],
		xaxis: {
			categories: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'],
			labels: {
				style:{
					colors: ["#9c9c9c", "#9c9c9c", "#9c9c9c", "#9c9c9c", "#9c9c9c", "#9c9c9c", "#9c9c9c", "#9c9c9c", "#9c9c9c", "#9c9c9c", "#9c9c9c", "#9c9c9c"],
					fontSize: '14px',
					fontFamily: 'Questrial'
				}
			},
			title: {
				style: {
					color: "#9c9c9c",
				}
			},
		},
		yaxis: {
			labels: {
				style: {
					colors:["#9c9c9c"] ,
					fontSize: '14px',
					fontFamily: 'Questrial'
				}
			}
		},
		tooltip: {
			custom: function({series, seriesIndex, dataPointIndex, w}) {
				return '<div class="chart-tooltip-container">' +
                '<div class="header">' +
				'<span class="title">' +
                w.globals.labels[dataPointIndex] +
				'</span>' +
                '</div>' +
                '<div class="content">' +
				'<span class="single-record"><span class="circle blue"></span> Netto: <span class="sum">' + series[0][dataPointIndex] + '</span></span>' +
                '<span class="single-record"><span class="circle gray"></span> Brutto: <span class="sum">' + series[1][dataPointIndex] + '</span></span>' +
                '</div>' +
                '</div>'
			}
		},
		fill: {
			colors: ['#5d88ff', '#e4e6ef'],
			opacity: 1
		},
		grid: {
			strokeDashArray: 5
		},
		legend: {
			show: false
		},
		dataLabels: {
			enabled: false
		},
		plotOptions: {
			bar: {
				startingShape: 'rounded',
				borderRadius: 5
			}
		},
		states: {
			hover: {
				filter: {
					type: 'none'
			  	}
			},
			active: {
				filter: {
					type: 'none'
				}
			}
		},
	}
	
	const series = [
		{
			name: "Netto",
			data: allSales.none
		},
		{
			name: "Brutto",
			data: allSales.vat
		},	
	]

	useEffect(() => {
		if(!userLoading){
			if(selectedCompany){
				if(!selectionYears){
					dispatch(retrieveSelectionYears({companyId: selectedCompany}))
				}					
				if(!activeSelectionYear && selectionYears && selectionYears.length > 0){
					dispatch(setActiveSelectionYear(selectionYears[0]))
					dispatch(retrieveOverviewRevenue({companyId: selectedCompany, year: selectionYears[0]}))
				}
				if(activeSelectionYear && selectionYears && selectionYears.length > 0){
					dispatch(retrieveOverviewRevenue({companyId: selectedCompany, year: activeSelectionYear}))
				}
			} else {
				dispatch(resetOverviewRevenue())
			}
		}

	}, [selectedCompany, userLoading, selectionYears, activeSelectionYear])


	useEffect(() => {
		if(Object.keys(sales).length > 0 && !loading){
			
			const list = []

			const valuesNone = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
			const valuesVat = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

			for(var sale in sales){
					
				const fullPrice = sales[sale].price
				const vat = sales[sale].vat
				const date = moment.unix(sales[sale].timestamp)

				if(date.month() + 1 === 1 && date.year() === parseInt(activeSelectionYear)){
					valuesNone[0] = valuesNone[0] + fullPrice
					valuesVat[0] = valuesVat[0] + (fullPrice * vat)
				}

				if(date.month() + 1 === 2 && date.year() === parseInt(activeSelectionYear)){
					valuesNone[1] = valuesNone[1] + fullPrice
					valuesVat[1] = valuesVat[1] + (fullPrice * vat)
				}

				if(date.month() + 1 === 3 && date.year() === parseInt(activeSelectionYear)){
					valuesNone[2] = valuesNone[2] + fullPrice
					valuesVat[2] = valuesVat[2] + (fullPrice * vat)
				}

				if(date.month() + 1 === 4 && date.year() === parseInt(activeSelectionYear)){
					valuesNone[3] = valuesNone[3] + fullPrice
					valuesVat[3] = valuesVat[3] + (fullPrice * vat)
				}

				if(date.month() + 1 === 5 && date.year() === parseInt(activeSelectionYear)){
					valuesNone[4] = valuesNone[4] + fullPrice
					valuesVat[4] = valuesVat[4] + (fullPrice * vat)
				}

				if(date.month() + 1 === 6 && date.year() === parseInt(activeSelectionYear)){
					valuesNone[5] = valuesNone[5] + fullPrice
					valuesVat[5] = valuesVat[5] + (fullPrice * vat)
				}

				if(date.month() + 1 === 7 && date.year() === parseInt(activeSelectionYear)){
					valuesNone[6] = valuesNone[6] + fullPrice
					valuesVat[6] = valuesVat[6] + (fullPrice * vat)
				}

				if(date.month() + 1 === 8 && date.year() === parseInt(activeSelectionYear)){
					valuesNone[7] = valuesNone[7] + fullPrice
					valuesVat[7] = valuesVat[7] + (fullPrice * vat)
				}

				if(date.month() + 1 === 9 && date.year() === parseInt(activeSelectionYear)){
					valuesNone[8] = valuesNone[8] + fullPrice
					valuesVat[8] = valuesVat[8] + (fullPrice * vat)
				}

				if(date.month() + 1 === 10 && date.year() === parseInt(activeSelectionYear)){
					valuesNone[9] = valuesNone[9] + fullPrice
					valuesVat[9] = valuesVat[9] + (fullPrice * vat)
				}

				if(date.month() + 1 === 11 && date.year() === parseInt(activeSelectionYear)){
					valuesNone[10] = valuesNone[10] + fullPrice
					valuesVat[10] = valuesVat[10] + (fullPrice * vat)
				}

				if(date.month() + 1 === 12 && date.year() === parseInt(activeSelectionYear)){
					valuesNone[11] = valuesNone[11] + fullPrice
					valuesVat[11] = valuesVat[11] + (fullPrice * vat)
				}

				list.push(sales[sale])

				if(list.length === sales.length){
					setAllSales({...allSales, none: valuesNone, vat: valuesVat});
				}
			}
			
		}
	}, [sales])

	const renderRegularRevenue = () => {
		if(!loading){
			return <NumberFormat thousandSeparator={" "} displayType={'text'} value={parseInt(_.sum(allSales.none)).toFixed(0)} />
		} else {
			return "Laster"
		}
	}

	const renderVatRevenue = () => {
		if(!loading){
			return <NumberFormat thousandSeparator={" "} displayType={'text'} value={parseInt(_.sum(allSales.vat)).toFixed(0)} />
		} else {
			return "Laster"
		}
	}
	
	return(
		<div className="revenue-details-container">
			<Chart
				options={options}
				series={series}
				type="bar"
				width="100%"
				height="400"
			/>
			<Row className="details-row">
				<Col className="details-col text-center">
				<div className="single-detail">
						<span className="small-title"><span className="icon netto"/>Netto</span>
						<h3 className="amount">{renderRegularRevenue()}</h3>
					</div>
				</Col>
				<Col className="details-col text-center">
					<div className="single-detail">
						<span className="small-title"><span className="icon brutto"/>Brutto</span>
						<h3 className="amount">{renderVatRevenue()}</h3>
					</div>
				</Col>
			</Row>
			{loading && <DashboardOverviewLoader/>}
		</div>
	)
}

export default Index





